import { api } from "../../api/api";
import { IAuth } from "../../contexts/AuthProvider/AuthProvider";
import { ICompanyOutlet } from "../../redux/companyOutlet/companyOutlet.types";

import {
	checkIfUserHasValidBillingCompany,
	checkIfUserHasValidBillingCompanyV2,
} from "./BillingCompanyProvider.helpers";
import {
	getBillingCompanyFromStorage,
	saveBillingCompanyInStorage,
} from "./BillingCompanyProvider.storage";
import { IBillingCompanyContextState } from "./BillingCompanyProvider.types";

export const fetchBillingCompanyInfoAsync = (
	affilated_company_outlet_uuids: IAuth["user"]["affilated_company_outlet_uuids"]
) =>
	new Promise<IBillingCompanyContextState | null>(async (resolve, reject) => {
		let company_outlet_uuid = null;
		if (affilated_company_outlet_uuids?.length > 0) {
			const currentComapnyInfo = getBillingCompanyFromStorage();
			console.log(currentComapnyInfo, "currentComapnyInfo#####");
			const hasValidComapny = affilated_company_outlet_uuids.find(
				(company) =>
					company.company_outlet_uuid === currentComapnyInfo.company_outlet_uuid
			);

			if (hasValidComapny) {
				company_outlet_uuid = hasValidComapny.company_outlet_uuid;
				//  saveBillingCompanyInStorage(hasValidComapny);
			} else {
				company_outlet_uuid =
					affilated_company_outlet_uuids[0].company_outlet_uuid;
				//  saveBillingCompanyInStorage(affilated_company_outlet_uuids[0]);
			}
		}

		if (!company_outlet_uuid) {
			return resolve(null);
		}

		const companyRes = await api.get(
			`/dataManagement/get-company-outlet?company_outlet_uuid=${company_outlet_uuid}`
		);

		const comapnyInfo = companyRes.data.data as ICompanyOutlet[];

		console.log(comapnyInfo, "comapnyInfo#####");
		resolve({ comapny: comapnyInfo[0] });
	});
